import React from 'react';
import { Widget } from '@typeform/embed-react';

const Poll = () => {
  return <Widget id="bND4BqMn" style={{ width: '100%', height: '420px' }} className="my-form" />;
};

export default Poll;
